"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var MessageFlashContext = react_1.createContext([
    {
        success: null,
        error: null,
    },
    function () { return ({}); },
]);
exports.FlashMessagesProvider = function (_a) {
    var children = _a.children, success = _a.success, error = _a.error;
    var _b = react_1.useState({ success: success, error: error }), state = _b[0], setState = _b[1];
    return (react_1.default.createElement(MessageFlashContext.Provider, { value: [state, setState] }, children));
};
exports.useFlashMessages = function () {
    var _a = react_1.useContext(MessageFlashContext), messages = _a[0], setMessages = _a[1];
    var flashError = function (msg) { return setMessages(function (state) { return (__assign(__assign({}, state), { error: msg })); }); };
    var flashSuccess = function (msg) { return setMessages(function (state) { return (__assign(__assign({}, state), { success: msg })); }); };
    var resetMessages = function () { return setMessages(function () { return ({ success: null, error: null }); }); };
    var resetSuccessMessage = function () { return setMessages(function () { return ({ success: null }); }); };
    var resetErrorMessage = function () { return setMessages(function () { return ({ error: null }); }); };
    return {
        flashError: flashError,
        flashSuccess: flashSuccess,
        resetMessages: resetMessages,
        resetSuccessMessage: resetSuccessMessage,
        resetErrorMessage: resetErrorMessage,
        messages: messages,
    };
};
//# sourceMappingURL=FlashMessages.js.map